{
  "close": "Затвори",
  "notifications": "{count, plural, one {# известие} other {# известия}}."
}
